<template>
  <v-toolbar flat class="my-2">
    <v-chip
      v-if="selectedData.length > 0"
      close
      @click:close="clearSelected"
    >
      {{ `${selectedData.length} data(s) selected` }}
    </v-chip>
    <v-spacer />
    <template>
      <v-btn
        color="primary"
        class="mb-2 rounded-pill elevation-0"
        @click="openSwitchModal"
        :style="{ 'margin-right': '10px' }"
        :disabled="loading"
        >Switch User
      </v-btn>
      <v-btn
        icon
        color="warning"
        class="mb-2"
        @click="getData"
        :style="{ 'margin-right': '10px' }"
        :loading="loading"
        :disabled="loading"
      >
        <v-icon>mdi-refresh</v-icon>
        <template v-slot:loader>
          <span class="custom-loader">
            <v-icon light>mdi-cached</v-icon>
          </span>
        </template>
      </v-btn>
    </template>
  </v-toolbar>
</template>

<script>
export default {
  props: {
    selectedData: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    clearSelected() {
      this.$emit("clear-selected");
    },
    openSwitchModal() {
      this.$emit("open-switch-modal");
    },
    getData() {
      this.$emit("get-data");
    },
  },
};
</script>
